import { trackEvent as t } from '../track';
import { DocumentMetadataProps, ShareInvitationMethod, GroupsMetadataProps } from './propertyTypes';

interface CollaboratorShareProps extends DocumentMetadataProps {
  '[Share] Invitation method': ShareInvitationMethod,
}

interface GroupShareProps extends DocumentMetadataProps, GroupsMetadataProps {
  '[Share] Invitation method': ShareInvitationMethod,
}

export const share = {
  collaborator: {
    complete: (props: CollaboratorShareProps) => t('[Share] [Document] [Add] Collaborator complete', props),
    error: (props: CollaboratorShareProps) => t('[Share] [Document] [Add] Collaborator error', props),
    initated: (props: CollaboratorShareProps) => t('[Share] [Document] [Add] Collaborator initiated', props),
    remove: (props: CollaboratorShareProps) => t('[Share] [Document] [Remove] Collaborator complete', props),
  },
  group: {
    complete: (props: GroupShareProps) => t('[Share] [Document] [Add] Group complete', props),
    error: (props: GroupShareProps) => t('[Share] [Document] [Add] Group error', props),
    initated: (props: GroupShareProps) => t('[Share] [Document] [Add] Group initiated', props),
    remove: (props: GroupShareProps) => t('[Share] [Document] [Remove] Group complete', props),
  },
  add: {
    click: (props: CollaboratorShareProps) => t('[Share] [Document] [Add] Initiated', props),
    hover: (props: CollaboratorShareProps) => t('[Share] [Document] [Add] Hover', props),
  },
  remove: {
    click: (props: CollaboratorShareProps) => t('[Share] [Document] [Remove] Initiated', props),
    hover: (props: CollaboratorShareProps) => t('[Share] [Document] [Remove] Hover', props),
  },
};
